import React from "react"
import '../footer/footer.css'
import { HashLink } from "react-router-hash-link";
import { Link } from "react-router-dom";
import Terms from "../pages/termsServices/terms";
import { useNavigate } from "react-router-dom";

export default function Footer() {
    const navigate = useNavigate();
    return (
        <footer className="footer-section position-relative overflow-hidden" id="footer">

            <span className="footer-circle footer-circle-1"></span>
            <span className="footer-circle footer-circle-2"></span>
            <span className="footer-circle footer-circle-3"></span>

            <div className="container position-relative">

                <div className="row gy-5">

                    <div className="col-lg-5 col-md-6">

                        <div className="footer-logo mb-4">
                            <img src="../assets/images/volt.png"
                                alt="Volt Learning"
                                className="img-fluid" />
                        </div>

                        <p className="footer-text mb-5">
                            Making learning engaging meaningful and future-ready
                            for every student.
                        </p>

                        <div className="d-flex gap-3">

                            <a href="https://www.facebook.com/VOLTLearning/" className="social-icon">
                                <img src="../assets/images/fb.svg" alt="" className="" />
                            </a>

                            <a href="https://x.com/VOLTLearning/" className="social-icon">
                                <img src="../assets/images/twittter.png" alt="" className="" />
                            </a>

                            <a href="https://www.instagram.com/VOLTLearning/" className="social-icon">
                                <img src="../assets/images/insta.svg" alt="" className="" />
                            </a>

                            <a href="https://www.youtube.com/@VOLTLearning" className="social-icon">
                                <img src="../assets/images/youtube.svg" alt="" className="" />
                            </a>

                        </div>

                    </div>

                    <div className="col-lg-3 col-md-6">

                        <h4 className="footer-heading mb-4">
                            Quick Links
                        </h4>

                        <ul className="footer-links ps-4 mb-0">

                            <li>
                                <HashLink smooth to="/#volt-section">
                                    About Volt Learning
                                </HashLink>
                            </li>

                            <li>
                                <HashLink smooth to="/#Assessment-Format">
                                    Assessment Format
                                </HashLink>
                            </li>

                            <li>
                                <HashLink smooth to="/#reward">
                                    Rewards
                                </HashLink>
                            </li>

                            <li>
                                <HashLink smooth to="/#how-it-works-section">
                                    How It Works
                                </HashLink>
                            </li>

                            <li>
                                <HashLink smooth to="/#faq">
                                    FAQ
                                </HashLink>
                            </li>

                        </ul>

                    </div>

                    <div className="col-lg-4">

                        <h4 className="footer-heading mb-4">
                            Contact Us
                        </h4>

                        <div className="d-flex align-items-center mb-4">

                            <div className="contact-icon me-3">
                                <img src="../assets/images/message.svg" alt="" className="" />
                            </div>

                            <a href="mailto:info@voltlearning.net"
                                className="footer-contact-text text-decoration-none">
                                info@voltlearning.net
                            </a>

                        </div>

                        <div className="d-flex align-items-center">

                            <div className="contact-icon me-3">
                                <img src="../assets/images/location.svg" alt="" className="" />
                            </div>

                            <p className="footer-contact-text mb-0">
                                Viva Books Private Limited<br />
                                4737/23, Ansari Road,<br />
                                Daryaganj, New Delhi 110002
                            </p>

                        </div>

                    </div>

                </div>

                <hr className="footer-divider" />

                <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3 pb-4">

                    <p className="copyright-text mb-0">
                        © 2025 Volt Learning
                    </p>

                    <Link
                        smooth to="/Terms_Services"
                        className="terms-link text-decoration-none"
                        reloadDocument
                    >
                        Terms of Service
                    </Link>

                </div>

            </div>

        </footer>
    )
}